import { useMemo } from "react";
import { useNexusStore } from "../store/nexusStore";
import { presentEvent, presentSnapshot } from "./mesh";

export function usePresentedSnapshot() {
  const snapshot = useNexusStore((state) => state.snapshot);
  const locale = useNexusStore((state) => state.locale);
  return useMemo(() => (snapshot ? presentSnapshot(snapshot, locale) : null), [snapshot, locale]);
}

export function usePresentedEvents() {
  const events = useNexusStore((state) => state.events);
  const locale = useNexusStore((state) => state.locale);
  return useMemo(() => events.map((event) => presentEvent(event, locale)), [events, locale]);
}
